<template>
    <div id="datatable-distributions-backoffice">
        <v-data-table
            :headers="headers"
            :items="listDistributions"
            :page="page"
            :pageCount="numberOfPages"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
                showFirstLastPage: true,
                'items-per-page-options': [10, 20, 50]
            }"
            dense
        >
            <template v-slot:[`item.actions-edit`]="{ item }">
                <div class="div-actions">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="$emit('on-edit-group', item)"
                                style="cursor: pointer"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <img
                                    src="/images/_SVGs/bo/edit_pencil.svg"
                                    :alt="$t('edit')"
                                    onload="SVGInject(this)"
                                    width="20"
                                    height="20"
                                />
                            </span>
                        </template>
                        <span>{{ $t("edit") }}</span>
                    </v-tooltip>
                </div>
            </template>
            <template v-slot:[`item.actions-delete`]="{ item }">
                <div class="div-actions">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span
                                @click="$emit('on-delete-group', item)"
                                style="cursor: pointer"
                                class="mr-2 p-0"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <img
                                    src="/images/_SVGs/bo/remove.svg"
                                    :alt="$t('delete')"
                                    onload="SVGInject(this)"
                                    width="30"
                                    height="30"
                                    class="circle"
                                />
                            </span>
                        </template>
                        <span>{{ $t("delete") }}</span>
                    </v-tooltip>
                </div>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        listDistributions: Array | Object,
        totalItems: Number | String,
        searchCount: Number,
    },
    data() {
        return {
            headers: [
                {
                    text: this.$t("backoffice.modules.promo-engine.number"),
                    align: "start",
                    value: "promoEngineGroupId",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.group-name"),
                    align: "start",
                    value: "name",
                    width: "10%",
                    class: "header-table-color",
                    sortable: true,
                },
                {
                    text: this.$t(
                        "backoffice.modules.promo-engine.participant-number"
                    ),
                    align: "start",
                    value: "entitiesCount",
                    width: "10%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.edit"),
                    align: "start",
                    value: "actions-edit",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
                {
                    text: this.$t("backoffice.modules.promo-engine.delete"),
                    align: "start",
                    value: "actions-delete",
                    width: "5%",
                    class: "header-table-color",
                    sortable: false,
                },
            ],
            page: 1,
            numberOfPages: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
            },
        };
    },
    watch: {
        "options.page": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.itemsPerPage": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        "options.sortBy": {
            handler() {
                this.$emit("alterTable", this.options);
            },
        },
        searchCount: {
            handler() {
                this.options.page = 1;
            },
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#datatable-distributions-backoffice {
    tr {
        height: 42px;
    }
}
</style>
